import { IAddUpdateBannerRequest } from "../../../model/admin-portal/request/add-update-banner-request";
import { IAddUpdateCategoryNewsRequest } from "../../../model/admin-portal/request/add-update-category-news-request";
import { IAddUpdateGovernamentalStrucutreRequest } from "../../../model/admin-portal/request/add-update-governamental-strucutre-request";
import { IAddUpdateLinkServiceRequest } from "../../../model/admin-portal/request/add-update-link-service-request";
import { IAddUpdateNewRequest } from "../../../model/admin-portal/request/add-update-news-request";
import { IAddUpdateCustomPageRequest } from "../../../model/admin-portal/request/add-update-custom-page-request";
import { ITermPaggedRequest } from "../../../model/admin-portal/request/term-pagged-request";
import { ICustomPagesListRequest } from "../../../model/admin-portal/request/custom-pages-list-request";
import { IBannersListResponse } from "../../../model/admin-portal/response/banners-list-response";
import { ICategoriesNewsListResponse } from "../../../model/admin-portal/response/categories-news-list-response";
import { IGovernamentalStructureReponse } from "../../../model/admin-portal/response/governamental-strutucture-response";
import { ILinkServicesListResponse } from "../../../model/admin-portal/response/link-services-list-response";
import { INewsListRespomse } from "../../../model/admin-portal/response/news-list-response";
import { ICustomPageListResponse } from "../../../model/admin-portal/response/custom-page-list-response";
import { PaginationResponse } from "../../../model/base/response/pagination-response";
import HttpClient from "../../services/http-client";
import ApplicationAppService from "../application-app-service";
import { serialize } from "object-to-formdata";
const defaultPath = 'Admin';

let applicationData = ApplicationAppService.getApplicationData();

var baseUrl = applicationData.municipalPortalUrl;


const listBanners = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IBannersListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IBannersListResponse>(), response.data));
};

const addUpdateBanner = async (params: IAddUpdateBannerRequest, file: File) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Banner`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};
const addUpdateNews = async (params: IAddUpdateNewRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });
    if (file !== null)
        formData.append("file", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/News`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addUpdateGovernamentalStrucuture = async (params: IAddUpdateGovernamentalStrucutreRequest, file: File | null) => {
    const formData = serialize(params, { indices: false, nullsAsUndefineds: false, booleansAsIntegers: false, allowEmptyArrays: false, noFilesWithArrayNotation: false, dotsForObjectNotation: false });

    if (file !== null)
        formData.append("image", file);

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/GovernamentalStructure`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const addUpdateCategoryNews = async (params: IAddUpdateCategoryNewsRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/CategoryNews`
    });
};

const addUpdateServiceLinks = async (params: IAddUpdateLinkServiceRequest) => {
    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: params,
        url: `/${defaultPath}/ServiceLink`
    });
};


const listNews = async (requst: ITermPaggedRequest): Promise<PaginationResponse<INewsListRespomse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/News`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<INewsListRespomse>(), response.data));
};

const listGovernamentalSctructure = async (requst: ITermPaggedRequest): Promise<PaginationResponse<IGovernamentalStructureReponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<IGovernamentalStructureReponse>(), response.data));
};

const listServiceLinks = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ILinkServicesListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ILinkServicesListResponse>(), response.data));
};


const listCategoryNews = async (requst: ITermPaggedRequest): Promise<PaginationResponse<ICategoriesNewsListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews`,
        params: requst
    }).then((response) => Object.assign(new PaginationResponse<ICategoriesNewsListResponse>(), response.data));
};


const getBanners = async (id: number): Promise<IBannersListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners/${id}`
    }).then((response) => Object.assign({} as IBannersListResponse, response.data));
};

const getGovernamentalStrucutre = async (id: number): Promise<IGovernamentalStructureReponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as IGovernamentalStructureReponse, response.data));
};


const getNews = async (id: number): Promise<INewsListRespomse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsListRespomse, response.data));
};


const getServiceLink = async (id: number): Promise<ILinkServicesListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks/${id}`,
    }).then((response) => Object.assign({} as ILinkServicesListResponse, response.data));
};


const getCategoryNews = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};



const deleteBanners = async (id: number): Promise<IBannersListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/Banners/${id}`
    }).then((response) => Object.assign({} as IBannersListResponse, response.data));
};

const deleteNews = async (id: number): Promise<INewsListRespomse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/News/${id}`,

    }).then((response) => Object.assign({} as INewsListRespomse, response.data));
};


const deleteServiceLinks = async (id: number): Promise<ILinkServicesListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/ServiceLinks/${id}`,
    }).then((response) => Object.assign({} as ILinkServicesListResponse, response.data));
};


const deleteCategoryNews = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/CategoriesNews/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};

const deleteGovernamentalStructure = async (id: number): Promise<ICategoriesNewsListResponse> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/GovernamentalStructure/${id}`
    }).then((response) => Object.assign({} as ICategoriesNewsListResponse, response.data));
};

// Custom Pages
const listCustomPages = async (request: ICustomPagesListRequest): Promise<PaginationResponse<ICustomPageListResponse>> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages`,
        params: request
    }).then((response) => Object.assign(new PaginationResponse<ICustomPageListResponse>(), response.data));
};

const getCustomPage = async (id: number): Promise<ICustomPageListResponse> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages/${id}`
    }).then((response) => Object.assign({} as ICustomPageListResponse, response.data));
};

const addUpdateCustomPage = async (params: IAddUpdateCustomPageRequest) => {
    const formData = new FormData();

    // Campos básicos da página
    if (params.id !== null && params.id !== undefined) {
        formData.append('Id', params.id.toString());
    }
    formData.append('Title', params.title || '');
    formData.append('MetaDescription', params.metaDescription || '');
    formData.append('MetaKeywords', params.metaKeywords || '');
    formData.append('PublicationDate', params.publicationDate.toISOString());
    formData.append('Published', params.published.toString());
    if (params.order !== null && params.order !== undefined) {
        formData.append('Order', params.order.toString());
    }

    // Serializar sections com índices
    if (params.sections && params.sections.length > 0) {
        params.sections.forEach((section, sIdx) => {
            // Campos da seção
            if (section.id !== null && section.id !== undefined) {
                formData.append(`Sections[${sIdx}].Id`, section.id.toString());
            }
            formData.append(`Sections[${sIdx}].Type`, section.type.toString());
            formData.append(`Sections[${sIdx}].Title`, section.title || '');
            formData.append(`Sections[${sIdx}].Content`, section.content || '');
            formData.append(`Sections[${sIdx}].Url`, section.url || '');
            formData.append(`Sections[${sIdx}].ImageFileName`, section.imageFileName || '');
            formData.append(`Sections[${sIdx}].Order`, section.order.toString());

            // Arquivo da seção
            if (section.file) {
                formData.append(`Sections[${sIdx}].File`, section.file);
            }

            // Items da seção
            if (section.items && section.items.length > 0) {
                section.items.forEach((item, iIdx) => {
                    if (item.id !== null && item.id !== undefined) {
                        formData.append(`Sections[${sIdx}].Items[${iIdx}].Id`, item.id.toString());
                    }
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Title`, item.title || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Subtitle`, item.subtitle || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Description`, item.description || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Url`, item.url || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].ImageFileName`, item.imageFileName || '');
                    formData.append(`Sections[${sIdx}].Items[${iIdx}].Order`, item.order.toString());

                    // Arquivo do item
                    if (item.file) {
                        formData.append(`Sections[${sIdx}].Items[${iIdx}].File`, item.file);
                    }
                });
            }
        });
    }

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/CustomPage`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const deleteCustomPage = async (id: number): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages/${id}`
    }).then((response) => response.data);
};

const listAllCustomPages = async (published?: boolean): Promise<ICustomPageListResponse[]> => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/CustomPages/All`,
        params: { Published: published }
    }).then((response) => response.data);
};

// ==================== MENUS ====================

const listMenus = async () => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus`
    }).then((response) => {
        // O endpoint retorna PagedCollection com structure { items: [], page, pageSize, totalCount }
        return response.data?.items || response.data || [];
    });
};

const getMenu = async (id: number) => {
    return await HttpClient.executeRequest({
        method: 'get',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus/${id}`
    }).then((response) => response.data);
};

const addUpdateMenu = async (params: any) => {
    const formData = new FormData();

    // Campos básicos do menu
    if (params.id !== null && params.id !== undefined) {
        formData.append('Id', params.id.toString());
    }
    formData.append('Title', params.title || '');
    formData.append('Order', params.order.toString());
    formData.append('Visible', params.visible.toString());

    // Vinculação do menu (página customizada ou URL externa)
    if (params.customPageId !== null && params.customPageId !== undefined) {
        formData.append('CustomPageId', params.customPageId.toString());
    }
    if (params.externalUrl) {
        formData.append('ExternalUrl', params.externalUrl);
    }

    // Items do menu
    if (params.items && params.items.length > 0) {
        params.items.forEach((item: any, idx: number) => {
            if (item.id !== null && item.id !== undefined) {
                formData.append(`Items[${idx}].Id`, item.id.toString());
            }
            formData.append(`Items[${idx}].Title`, item.title || '');
            if (item.customPageId !== null && item.customPageId !== undefined) {
                formData.append(`Items[${idx}].CustomPageId`, item.customPageId.toString());
            }
            if (item.externalUrl) {
                formData.append(`Items[${idx}].ExternalUrl`, item.externalUrl);
            }
            formData.append(`Items[${idx}].Order`, item.order.toString());
            formData.append(`Items[${idx}].Visible`, item.visible.toString());
        });
    }

    return await HttpClient.executeRequest({
        method: params.id === undefined || params.id === null ? 'post' : 'put',
        baseURL: baseUrl,
        data: formData,
        url: `/${defaultPath}/Menu`,
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
};

const deleteMenu = async (id: number): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'delete',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus/${id}`
    }).then((response) => response.data);
};

const reorderMenus = async (menuIds: number[]): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        url: `/${defaultPath}/Menus/Reorder`,
        data: { MenuIds: menuIds }
    }).then((response) => response.data);
};

const reorderMenuItems = async (menuItemIds: number[]): Promise<void> => {
    return await HttpClient.executeRequest({
        method: 'patch',
        baseURL: baseUrl,
        url: `/${defaultPath}/MenuItems/Reorder`,
        data: menuItemIds
    }).then((response) => response.data);
};

const AdminPortalAppService = {
    deleteGovernamentalStructure, addUpdateGovernamentalStrucuture, getGovernamentalStrucutre, listGovernamentalSctructure, deleteBanners, deleteNews, deleteCategoryNews, deleteServiceLinks, listBanners, listCategoryNews, addUpdateCategoryNews, addUpdateServiceLinks, addUpdateNews, listNews, listServiceLinks, getBanners, getCategoryNews, getServiceLink, getNews, addUpdateBanner,
    listCustomPages, getCustomPage, addUpdateCustomPage, deleteCustomPage, listAllCustomPages,
    listMenus, getMenu, addUpdateMenu, deleteMenu, reorderMenus, reorderMenuItems
};

export default AdminPortalAppService